import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";
import nb from "i18n-iso-countries/langs/nb.json";
import sv from "i18n-iso-countries/langs/sv.json";

countries.registerLocale(en);
countries.registerLocale(nb);
countries.registerLocale(sv);

export const OPTIONS_COUNTRIES = "options.countries";

const localeToIso: Record<string, string> = {
    "en-US": "en",
    "nb-NO": "nb",
    "sv-SE": "sv",
};

const englishNameOverrides: Record<string, string> = {
    "Netherlands Antilles": "AN",
    "Bolivia, Plurinational State of": "BO",
    "Congo, Democratic Republic of the": "CD",
    "Cabo Verde": "CV",
    "United Kingdom of Great Britain and Northern Ireland": "GB",
    "Iran, Islamic Republic of": "IR",
    "Korea, Democratic People's Republic of": "KP",
    "Netherlands, Kingdom of the": "NL",
    "Palestine, State of": "PS",
    Réunion: "RE",
    "Saint Helena, Ascension and Tristan da Cunha": "SH",
    "Tanzania, United Republic of": "TZ",
    "Holy See": "VA",
    "Venezuela, Bolivarian Republic of": "VE",
    "Virgin Islands (British)": "VG",
    "Virgin Islands (U.S.)": "VI",
    "Viet Nam": "VN",
};

const iso2ForEnglishName = (englishName: string): string | undefined =>
    englishNameOverrides[englishName] ?? countries.getAlpha2Code(englishName, "en");

export const localizeCountryOption = (englishName: string, locale: string): string => {
    const iso = localeToIso[locale];
    if (!iso) return englishName;
    const code = iso2ForEnglishName(englishName);
    if (!code) return englishName;
    return countries.getName(code, iso) ?? englishName;
};

export const countryCodes = (): string[] => Object.keys(countries.getAlpha2Codes());

export const countryName = (code: string, locale: string): string =>
    countries.getName(code, localeToIso[locale] ?? "en") ?? code;
